/**
 * GigBoostBadge
 *
 * Small green pill rendered on Live Rooms that are currently under an
 * active Org assignment (UPDATE.md §9.3). Shows the Creator's payout
 * percentage and an optional days-remaining countdown:
 *
 *   [boost icon] Gig Boost · 90% payout · 41 days left
 *
 * Reusable: render this anywhere a Live Room appears (AssignmentCard,
 * LiveRoomPage, Org Shows nested rows, …). All copy is i18n'd — the
 * component never sees raw English strings.
 */

import React from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import Icon from '../Icon/Icon';

import css from './GigBoostBadge.module.css';

const GigBoostBadge = props => {
  const { className, payoutPercent, daysRemaining } = props;

  const hasPayout = typeof payoutPercent === 'number';
  const hasDays = typeof daysRemaining === 'number' && daysRemaining >= 0;

  return (
    <span className={classNames(css.root, className)}>
      <Icon name="boost" size={14} />
      <span className={css.label}>
        <FormattedMessage id="GigBoostBadge.label" />
      </span>
      {hasPayout ? (
        <span className={css.divider} aria-hidden>
          ·
        </span>
      ) : null}
      {hasPayout ? (
        <span className={css.payout}>
          <FormattedMessage id="GigBoostBadge.payout" values={{ percent: payoutPercent }} />
        </span>
      ) : null}
      {hasDays ? (
        <span className={css.divider} aria-hidden>
          ·
        </span>
      ) : null}
      {hasDays ? (
        <span className={css.days}>
          <FormattedMessage id="GigBoostBadge.daysLeft" values={{ count: daysRemaining }} />
        </span>
      ) : null}
    </span>
  );
};

GigBoostBadge.defaultProps = {
  className: null,
  payoutPercent: null,
  daysRemaining: null,
};

GigBoostBadge.propTypes = {
  className: string,
  payoutPercent: number,
  daysRemaining: number,
};

export default GigBoostBadge;
